export const DisclaimerDevice: string[] = [
  "The binding period is 36 months and thereafter the agreement continues with a 3-month mutual notice period.",
  "The monthly cost is invoiced monthly in advance.",
];
